import { graphStore } from "../graph-store"

// Bootstraps the data-loaded state for listeners that can't observe the
// store directly (e.g., launcher-button). Pages call this once on load; it
// fires a one-time store-state-bootstrap event with the current hasData.
// After bootstrap, store-updated/store-cleared events carry the rest.
//
// This indirection keeps launcher-button (and other UI-only components)
// from importing graph-store, which would otherwise drag a SharedWorker
// construction into every view-component test file that mounts them.
export async function bootstrapStoreState(): Promise<void> {
  try {
    const size = await graphStore.size()
    document.dispatchEvent(
      new CustomEvent("store-state-bootstrap", {
        detail: { hasData: size > 0 },
      }),
    )
  } catch (e) {
    console.error("store-state: bootstrap failed", e)
  }
}
